export enum TimelineActionStatus {
    Upcoming,
    InProgress,
    Completed,
}